import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import customerIllustration from '../../../../assets/images/customer_illustration.svg';
import FormLoader from '../../common/FormLoader';
import * as common from '../../common/__redux/commonRedux';
import CustomToast from '../../common/CustomToast';
import { useDictionary } from '../../../../utilities/hooks/UseDictionary';
import ConfirmationModal from '../../common/ConfirmationModal';
import { createCutomer, getProviderCustomer, updateCustomerInfo } from './networking';

const CustomerHandlerForms = ({ type, showDialog, setShowDialog, customerSaveEvent, editId }) => {
    const dictionary = useDictionary();
    const [showDialogAnimation, setShowDialogAnimation] = useState(false);
    const [showLoader, setShowLoader] = useState(false);
    //Forms States
    const [customerNameValue, setCustomerNameValue] = useState('');
    const [customerEmailValue, setCustomerEmailValue] = useState('');
    const [customerPhoneValue, setCustomerPhoneValue] = useState('');
    const [customerNotesValue, setCustomerNotesValue] = useState('');

    const [customerErrors, setCustomerErrors] = useState({
        customerPhone: '',
        customerEmail:''
    });

    const [enableCreating, setEnableCreating] = useState(false);
    const [showDismissDialog, setDismissDialogVisibility] = useState(false);
    const [prevDataObject, setPrevDataObject] = useState({});
    const [enabled, setEnabled] = useState(false);
    const [showLoaderMessage, setShowLoaderMessage] = useState(false);
    const [loaderMessage, setLoaderMessage] = useState(null);

    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    useEffect(() => {
        setPrevDataObject({
            name: '',
            email: '',
            phone: '',
            notes: ''
        })
        if (type === 'edit') {
            getCustomernfo();
        }

    }, []);


    useEffect(() => {
        setTimeout(() => {
            setShowDialogAnimation(true);
            setEnableCreating(true);
		}, 50);
    }, [showDialog]);

    const getCustomernfo = async () => {
        setShowLoader(true);
        try {
            let { data } = await getProviderCustomer(editId);
            if (data) {
                const normalizedPhone = (data.phone || '').replace(/^\+/, '');
                setCustomerNameValue(data.name || '');
                setCustomerEmailValue(data.email || '');
                setCustomerPhoneValue(normalizedPhone);
                setCustomerNotesValue(data.notes || '');
                setPrevDataObject({
                    name: data.name || '',
                    email: data.email || '',
                    phone: normalizedPhone,
                    notes: data.notes || ''
                })
            }
            setShowLoader(false);
        } catch (e) {
            setShowLoader(false);
        }
    };

    const handleTitleChange = (event) => {
        setCustomerNameValue(event.target.value);
    };

    const handleEmailChange = (e) => {
        const value = e.target.value;
        setCustomerEmailValue(value);

        if (!emailRegex.test(value)) {
            setCustomerErrors((prevErrors) => ({
                ...prevErrors,
                customerEmail: dictionary.invalid_email,
            }));
        } else {
            setCustomerErrors((prevErrors) => ({
                ...prevErrors,
                customerEmail: '',
            }));
        }
    }

    const handlePhoneChange = (value) => {
        setCustomerPhoneValue(value);

        if (value.length > 20) {
            setCustomerErrors((prevErrors) => ({
                ...prevErrors,
                customerPhone: dictionary.phone_length_error,
            }));
        } else {
            setCustomerErrors((prevErrors) => ({
                ...prevErrors,
                customerPhone: '',
            }));
        }
    }
    const handleNotesChange = (e) => {
        setCustomerNotesValue(e.target.value);
    };

    const dismissDialog = () => {
        if(JSON.stringify(prevDataObject) === JSON.stringify({name: customerNameValue, email: customerEmailValue, phone:customerPhoneValue,notes: customerNotesValue})) {
            setShowDialogAnimation(false);
            setTimeout(() => {
                setShowDialog(false);
            }, 600);
        } else {
            setDismissDialogVisibility(true);
        }
    };
    const dismissDialogBox = () => {
        setShowDialogAnimation(false);
        setTimeout(() => {
            setShowDialog(false);
        }, 600);
    };
    
    const validateForm = () => {
        const newErrors = {
            customerEmail: '',
            customerPhone: ''
        };

        if(!customerEmailValue && !customerPhoneValue) {
            newErrors.customerEmail = dictionary.invalid_email;
            newErrors.customerPhone = dictionary.phone_length_error;
        }
        else if(customerEmailValue && customerPhoneValue) {
            if (!emailRegex.test(customerEmailValue)) {
                newErrors.customerEmail = dictionary.invalid_email;
            }
            if (isNaN(customerPhoneValue) || customerPhoneValue.length > 20) {
                newErrors.customerPhone = dictionary.phone_length_error;
            }
        }
        else if(customerEmailValue) {
            if (!emailRegex.test(customerEmailValue)) {
                newErrors.customerEmail = dictionary.invalid_email;
            }
        }
        else if(customerPhoneValue) {
            if (isNaN(customerPhoneValue) || customerPhoneValue.length > 20) {
                newErrors.customerPhone = dictionary.phone_length_error;
            }
        }
    
        setCustomerErrors(newErrors);
        return Object.values(newErrors).every((error) => error === '');
    };
    

    const onFinishClicked = () => {
        if (validateForm()) {
            if (type === 'edit') {
                updateCustomer();
            } else {
                createCustomer();
            }
        }
    };

    const updateCustomer = async () => {
        setShowLoader(true);
        setEnableCreating(false);
        try {
            let body = {
                name: customerNameValue,
                email: customerEmailValue,
                phone: customerPhoneValue ? `+${customerPhoneValue}` : '',
                notes: customerNotesValue
            };
            await updateCustomerInfo(editId, body);
            setShowLoader(false);
            customerSaveEvent();
            dismissDialogBox();
        } catch (e) {
            setEnableCreating(true);
            setShowLoader(false);
            if (e?.response?.data?.message) {
                toast.error(<CustomToast message={e?.response?.data.error_code === 3405 ? dictionary.customer_already_exist :e.response.data.message} />, {
                    position: 'top-right',
                    autoClose: 5000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: false,
                    draggable: false,
                    progress: undefined,
                    closeButton: false,
                    icon: false,
                    className: 'toast-white-error'
                });
            }
        }
    };

    const createCustomer = async () => {
        setShowLoader(true);
        setEnableCreating(false);
        try {
            let body = {
                name: customerNameValue,
                email: customerEmailValue,
                phone: customerPhoneValue ? `+${customerPhoneValue}` : '',
                notes: customerNotesValue
            };
            const { data } = await createCutomer(body);
            setShowLoader(false);
            customerSaveEvent();
            dismissDialogBox();
        } catch (e) {
            setEnableCreating(true);
            setShowLoader(false);
            if (e?.response?.data?.message) {
                toast.error(<CustomToast message={e?.response?.data.error_code === 3405 ? dictionary.customer_already_exist : e.response.data.message} />, {
                    position: 'top-right',
                    autoClose: 5000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: false,
                    draggable: false,
                    progress: undefined,
                    closeButton: false,
                    icon: false,
                    className: 'toast-white-error'
                });
            }
        }
    };

    useEffect(() => {
        setEnabled(customerNameValue !== '' && (customerEmailValue !== '' || customerPhoneValue !== ''));
    }, [customerNameValue,customerEmailValue,customerPhoneValue]);

    return (
        <div className={`Customer-wrapper group-category-tags-wrapper${showDialogAnimation ? ' group-category-tags-wrapper-visible' : ''}`}>
            <div className="group-dialog-content-wrapper thin-scrollbar">
                <div
                    className="dialog-close-button"
                    style={{ right: '24px', top: '24px' }}
                    onClick={dismissDialog}
                />
                <img src={customerIllustration} />
                <div className="group-dialog-content-container group-dialog-content-form-container">
                    <h2
                        style={{
                            whiteSpace: 'pre-line',
                            marginBottom: 32,
                            lineHeight: '24px'
                        }}
                    >
                        {type === 'create' ? dictionary.create_new_customer : dictionary.edit_customer}
                    </h2>
                    <div className="group-inputs text-name-wrapper" style={{ marginTop: '16px', marginBottom: 16 }}>
                        <label style={{ marginBottom: 8 }}>
                            {dictionary.providerName}
                        </label>
                        <input type="text" maxLength='40' placeholder={dictionary.placeholder_customer_full_name} value={customerNameValue} onChange={handleTitleChange} />
                        <div className="textarea-info-row textarea-info-row-counter">
                            <div className="text textarea-info-row-counter-text">{customerNameValue.trim().length + '/' + 40}</div>
                        </div>
                    </div>
                    <div className="group-inputs text-name-wrapper" style={{ marginTop: '16px', marginBottom: 16 }}>
                        <label style={{ marginBottom: 8 }}>
                            {dictionary.providerEmail}
                        </label>
                        <input type="text" maxLength='50' placeholder={dictionary.placeholder_enter_email} value={customerEmailValue} onChange={handleEmailChange} />
                        {customerErrors.customerEmail && <small className="input-error-message">{customerErrors.customerEmail}</small>}
                    </div>
                    <div className="group-inputs text-name-wrapper provider-customers-number-input" style={{ marginTop: '16px', marginBottom: 16 }}>
                        <label style={{ marginBottom: 8 }}>
                            {dictionary.providerPhoneNumber}
                        </label>
                        <PhoneInput
                            country={'gr'}
                            placeholder={dictionary.placeholder_phone_format}
                            value={customerPhoneValue}
                            onChange={handlePhoneChange}
                        />
                        {customerErrors.customerPhone && <small className="input-error-message">{customerErrors.customerPhone}</small>}
                    </div>
                    <div className="group-inputs text-name-wrapper" style={{ marginTop: '16px', marginBottom: 16 }}>
                        <label style={{ marginBottom: 8 }}>
                            {dictionary.notes}
                        </label>
                        <textarea style={{marginTop: '0px'}} rows="4" cols="50" maxLength='255' onChange={handleNotesChange} defaultValue={customerNotesValue} />
                        <div className="textarea-info-row textarea-info-row-counter" style={{ marginTop: '3px'}}>
                            <div className="text textarea-info-row-counter-text">{customerNotesValue.trim().length + '/' + 255}</div>
                        </div>
                    </div>
                </div>
            </div>

            <FormLoader
                onDismissClicked={dismissDialog}
                showMessage={showLoaderMessage}
                message={loaderMessage}
                rounded={true}
                showLoader={showLoader}
                showEnter={false}
            />

            <div className="group-dialog-button-container">
                <button
                    disabled={!enableCreating}
                    onClick={enabled ? onFinishClicked : null}
                    className={enabled ? 'button' : 'button button-disabled'}
                    data-testid="group-dialog-finish-button"
                >
                    {dictionary.save}
                </button>
            </div>
            {showDismissDialog ? (
                <ConfirmationModal
                    setShowModal={setDismissDialogVisibility}
                    asyncTask={dismissDialogBox}
                    title={dictionary.dismiss_dialog}
                    action={dictionary.dismiss}
                />
            ) : null}
            <ToastContainer />
        </div>
    );
};

CustomerHandlerForms.propTypes = {
    type: PropTypes.string,
    showDialog: PropTypes.bool,
    setShowDialog: PropTypes.func,
    customerSaveEvent: PropTypes.func,
    editId: PropTypes.string,
};

export default connect(common.states, common.actions)(CustomerHandlerForms);